import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import MasterPage from '../../layouts/MasterPage';
import { Link } from 'react-router-dom';
import authAPI from '../../api/authAPI';
import AuthenticationManager from '../../services/StorageJWT';
import PopupBox from '../../components/PopupBox';

const Menu = () => {
  const navigate = useNavigate();
  const _auth=new AuthenticationManager()
  const [errorText, setErrorText] = useState('این بخش به زودی فعال خواهد شد');
  const [show, setShow] = useState(false);
  useEffect(() => {}, []);
  const logout=()=>{
    authAPI.logout(_auth._token)
    
    .then(res=>{
     
      _auth.logout()
    }).catch(e=>{})
    .finally(()=>document.location.reload(true))
  }
  return (
    <MasterPage>
      <div className="structure-page login p-3 body menu ">
        <div className="text-center w-100 mt-3">
          <Link className="menu-item" role='button' to={'/menu/profile'}>
            <span>
              <img src="/icons/profile.svg" />{' '}
            </span>
            <span>مشخصات فردی</span>
          </Link>
          <Link className="menu-item" role='button' to={'/menu/games'}>
            <span>
              <img src="/icons/game-list.svg" />{' '}
            </span>
            <span>لیست بازی ها</span>
          </Link>
  
          <Link className="menu-item" role='button' to={'/menu/points'}>
            <span>
              <img src="/icons/points.svg" />{' '}
            </span>
            <span>امتیازات</span>
          </Link>
          <div className="menu-item" role='button' onClick={()=>setShow(true)}>
            <span>
              <img src="/icons/share.svg" />{' '}
            </span>
            <span>معرفی به دوستان</span>
          </div>
          <Link className="menu-item" role='button' to={'/menu/messages'}>
            <span>
              <img src="/icons/notif.svg" />{' '}
            </span>
            <span>اعلان ها</span>
          </Link>
          <div className="menu-item red-color-2" role='button' onClick={logout}>
           
            <span>خروج</span>
          </div>
          <PopupBox show={show} setShow={setShow} text={errorText} />
        </div>
        <button
          onClick={() => navigate(-1)} 
          className="btn btn-return pt-2 pb-2 w-100"
        >
          بازگشت
        </button>
      </div>
    </MasterPage>
  );
};

export default Menu;
